// src/features/system/api.ts
import { queryOptions } from "@tanstack/react-query";

import { api, call } from "@/api/client";

/** حالة المنصة العامة (وضع الصيانة والإعلان)، بلا مصادقة، وتُحدَّث كل دقيقة. */
export const systemStatusQuery = queryOptions({
  queryKey: ["system", "status"],
  queryFn: () =>
    call(api.GET("/api/system/status")) as Promise<{
      maintenance: boolean; maintenance_message: string; announcement: string; nafath_available: boolean; nafath_mock: boolean;
      login_otp_enabled: boolean; login_google_enabled: boolean; google_oauth_client_id: string | null;
    }>,
  staleTime: 30_000,
  refetchInterval: 60_000,
  refetchOnWindowFocus: true,
  retry: false,
});
